module.exports = ".deletePopupConatiner {\n    height: 120px;\n    width: 315px;\n}\n\n.deleteTitle {\n    padding: 15px;\n    padding-top: 20px;\n}\n\n.deleteButtons {\n    margin-right: 10px;\n}\n\n.delPopupbtn {\n    width: 60px;\n    min-width: 60px!important;\n    height: 30px;\n    line-height: 0px;\n    margin-right: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/deletePopup/deletePopup.component.css
// module id = ./src/app/shared/deletePopup/deletePopup.component.css
// module chunks = main